/* Google Tag Manager Events
 * Docs: https://developers.google.com/tag-manager/devguide */

import {AnalyticsService} from "../../../services/analytics-service";

export default function init() {
	addListeners();

	const $courseMenuRecommendedCourseLinks = document.querySelectorAll('.courses-nav-list.-recommendations .course-label:not(.-proftest)');
	$courseMenuRecommendedCourseLinks.forEach(($link) => {
		$link.addEventListener('click', () => {
			AnalyticsService.sendEvent('recommended_course_menu');
		});
	});

	const $ucanPageLinks = document.querySelectorAll('.courses-nav-list.-recommendations .ucan-logo-group');
	$ucanPageLinks.forEach(($link) => {
		$link.addEventListener('click', () => {
			AnalyticsService.sendEvent('ucan_course_menu');
		});
	});
}

function addListeners() {
    const pageName = craft.page.handle;

	sharedEvents();

	switch (pageName) {

		case 'coursesEntry':
			coursesEntryEvents();
			break;
	}
}

function sharedEvents() {
    initEvent('a[href^="tel:"]', {
    	'event': 'phone_click'
    });

    initEvent('a[href^="mailto:"]', {
    	'event': 'email_click'
    });

    initEvent('#btn-consultation-pinned', {
    	'event': 'free_consultation_top_button'
    });

    setTimeout(() => {
		initEvent('[data-lang-switcher="ru"]', {
			'event': 'switch_ru'
		});
		initEvent('[data-lang-switcher="uk"]', {
			'event': 'switch_ua'
		});
	}, 3000);
}

function coursesEntryEvents() {
	initEvent('#btn-consultation-hero', {
		'event': 'free_consultation_button'
	});

	initEvent('#modal-quiz-trigger', {
		'event': 'get_test_button'
	});

	initEvent('.coach-card', {
		'event': 'coach_info_click'
	});
}

function initEvent(selector, dataLayerObj, cb) {
    const $triggers = document.querySelectorAll(selector);

    if ($triggers.length) {
		$triggers.forEach(($trigger) => {
			$trigger.addEventListener('click', () => {
				if (dataLayerObj) AnalyticsService.sendEvent(dataLayerObj['event'], dataLayerObj);
				if (cb) cb();
			});
		});
	}
}